import request from '@/utils/request'
const centerApi = {
  // 修理厂用户账号激活
  clientActivationSubmit: (data) => {
    return request({
      url: '/client/activation/submit',
      method: 'post',
      data
    })
  },
  // 激活验证码
  sendClientVerifyCode () {
    return request({
      url: `/client/activation/verify-code`,
      method: 'get'
    })
  },
  queryPointList: (params) => {
    return request({
      url: `/point/list`,
      method: 'get',
      params
    })
  },
  queryPointHistoryList: (params) => {
    return request({
      url: `/point/history/list`,
      method: 'get',
      params
    })
  },
  queryPointDetailList: () => {
    return request({
      url: `/point/detail/list`,
      method: 'get'
    })
  },
  getCassLoginHelpImg: (data) => {
    return request({
      url: '/public/apply/image',
      method: 'post',
      data
    })
  },
  // 获取vip卡数据
  queryVipCard: () => {
    return request({
      url: `/vip-card/query`,
      method: 'get'
    })
  },
  getAddressSubList: (params) => {
    return request({
      url: `/client/address/sub/list`,
      method: 'get',
      params
    })
  },
  // 收藏列表
  getFavoriteList: (params) => {
    return request({
      url: `/favorite/list`,
      method: 'get',
      params
    })
  },
  // 员工信息
  queryClientUserList: (params) => {
    return request({
      url: `/client/user/list`,
      method: 'get',
      params
    })
  },
  queryClientUserInfo: (params) => {
    return request({
      url: `/client/user/info`,
      method: 'get',
      params
    })
  },
  // 员工申请
  queryClientUserApplyList: (params) => {
    return request({
      url: `/client/user/apply/list`,
      method: 'get',
      params
    })
  },
  // 审核员工申请
  clientUserApplyVerify: (data) => {
    return request({
      url: '/client/user/apply-verify',
      method: 'post',
      data
    })
  },
  // 修改员工身份、状态
  clientUserWorkshopUpdateStatus: (data) => {
    return request({
      url: '/client/user/workshop/update-status',
      method: 'post',
      data
    })
  },
  // 注册
  registerSubmit: (data) => {
    return request({
      url: '/register/submit',
      method: 'post',
      data
    })
  },
  registerWorkerSubmit: (data) => {
    return request({
      url: '/register/worker/submit',
      method: 'post',
      data
    })
  },
  // 注册 验证码
  publicRegisterVerifyCode: (params) => {
    return request({
      url: `/public/register/verify-code`,
      method: 'get',
      params
    })
  },
  // 员工注册查询修理厂
  publicWorkshopQuery: (params) => {
    return request({
      url: `/public/workshop/query`,
      method: 'get',
      params
    })
  },
  registerCheck: (data) => {
    return request({
      url: '/register/check',
      method: 'post',
      data
    })
  },
  // 修改关键信息
  clientUpdateKey: (data) => {
    return request({
      url: '/client/update-key',
      method: 'post',
      data
    })
  },
  // 修改基本信息
  clientUserUpdateUserBasic: (data) => {
    return request({
      url: '/client/user/update/user-basic',
      method: 'post',
      data
    })
  },
  // 修改关键信息 验证码
  clientUpdateGeneralVerifyCode: (params) => {
    return request({
      url: `/client/update-general/verify-code`,
      method: 'get',
      params
    })
  },
  // 修改密码
  clientUserUpdateUserPassword: (data) => {
    return request({
      url: '/client/user/update/user-password',
      method: 'post',
      data
    })
  },
  // 修改密码验证码
  publicResetPasswordVerifyCode: (params) => {
    return request({
      url: `/public/reset-password/verify-code`,
      method: 'get',
      params
    })
  },
  clientUserWorkshopList: () => {
    return request({
      url: `/client/user/workshop/list`,
      method: 'get'
    })
  },
  // 获取用户信息
  getClientInfo: () => {
    return request({
      url: `/client/info`,
      method: 'get'
    })
  },
  // 切换修理厂
  clientUserWorkshopChange: (data) => {
    return request({
      url: '/client/user/workshop/change',
      method: 'post',
      data
    })
  },
  // 店主身份转移-验证码
  clientUserWorkshopTransferVerifyCode: (params) => {
    return request({
      url: `/client/user/workshop/transfer/verify-code`,
      method: 'get',
      params
    })
  },
  clientUserWorkshopTransfer: (data) => {
    return request({
      url: '/client/user/workshop/transfer',
      method: 'post',
      data
    })
  },
  clientUserAccountLogout: (data) => {
    return request({
      url: 'client/user/account-logout',
      method: 'post',
      data
    })
  },
  // 忘记密码
  publicResetPassword: (data) => {
    return request({
      url: '/public/reset-password',
      method: 'post',
      data
    })
  },
  clientQueryClientCount: (params) => {
    return request({
      url: `/client/query/client-count`,
      method: 'get',
      params
    })
  },
  // 修改订单地址
  updateDetailAddress: (data) => {
    return request({
      url: '/order/detailAddress/update',
      method: 'post',
      data
    })
  }
}

export default centerApi
